import AutoSizer from "react-virtualized-auto-sizer";

interface ResponsiveContainerProps {
  children: (props: { width: number; height: number }) => React.ReactNode;
}

const maxHeight = 300;
const minHeight = 200;

export function ResponsiveContainer({ children }: ResponsiveContainerProps) {
  return (
    <div
      style={{
        maxHeight,
        minHeight,
        width: "100%",
      }}
    >
      <AutoSizer disableHeight>
        {({ width }) =>
          children({
            width,
            height: Math.min(maxHeight, width * 0.5625),
          })
        }
      </AutoSizer>
    </div>
  );
}
